<template>
	<div id="usuario-editar">
		<ld-popup
			id="popup-editar-usuario"
			class="popup-usuario"
			:fullscreen="true"
			:active.sync="activePopup"
			:button-close-hidden="true"
			:disabledBackgoundClose="true"
			:closed="funcaoFechar"
		>
			<template v-if="usuario">
				<div
					class="header-container flex flex-wrap justify-between w-full p-2 pb-5"
					slot="header"
				>
					<div class="title-container flex items-center flex-1">
						<div class="content-title flex flex-col items-start">
							<h2 class="title">Editar usuário</h2>
							<div
								v-if="
									usuario &&
										usuario.empresa &&
										usuario.empresa.nome
								"
								class="flex items-center"
							>
								<h4 class="text-base">
									{{ usuario.empresa.nome }}
								</h4>
							</div>
						</div>
					</div>

					<div
						v-if="
							$permissions.can('colaboradorexcluir') ||
								$permissions.can('autenticadosuperuser')
						"
						class="button-bloqueado-container flex justify-end mr-6"
					>
						<ld-button
							:color="
								usuario && usuario.bloqueado === 'Bloqueado'
									? 'success'
									: 'danger'
							"
							icon-pack="feather"
							:icon="
								usuario && usuario.bloqueado === 'Bloqueado'
									? 'icon-unlock'
									: 'icon-lock'
							"
							@click="popupBloquearUsuario = true"
						>
							{{
								usuario && usuario.bloqueado === "Bloqueado"
									? "Desbloquear usuário"
									: "Bloquear usuário"
							}}
						</ld-button>
					</div>

					<ld-button
						icon-pack="feather"
						icon="icon-x"
						size="large"
						color="dark"
						type="flat"
						@click="
							() => {
								if (
									$permissions.can('colaboradormodificar') ||
									$permissions.can('autenticadosuperuser')
								) {
									popupCancelarEdicao = true;
								} else if (
									!$permissions.can('colaboradormodificar') &&
									!$permissions.can('autenticadosuperuser')
								) {
									cancelarEdicao();
								}
							}
						"
					></ld-button>
				</div>

				<vx-card>
					<form
						v-if="usuario"
						id="form-editar-usuario"
						class="py-5 md:px-4"
						@submit.prevent="editarUsuario"
					>
						<geral
							:usuario.sync="usuario"
							:foto.sync="usuario.foto"
							:fotoThumb.sync="usuario.fotoThumb"
							:nome.sync="usuario.nome"
							:cpf.sync="usuario.cpf"
							:email.sync="usuario.email"
							:telefone.sync="usuario.telefone"
							:dataNascimento.sync="usuario.dataNascimento"
							:cep.sync="usuario.cep"
							:logradouro.sync="usuario.logradouro"
							:numero.sync="usuario.numero"
							:complemento.sync="usuario.complemento"
							:bairro.sync="usuario.bairro"
							:cidade.sync="usuario.cidade"
							:estado.sync="usuario.estado"
							:cpfDisabled="true"
							:removeError="removeError"
							:edicao="true"
						/>

						<estrutura-permissao
							:empresa.sync="usuario.empresa"
							:empresas.sync="empresas"
							:perfil.sync="usuario.perfil"
							:gerenciados.sync="usuario.gerenciados"
							:perfilAtualPk.sync="perfilAtualPk"
							:usuarioPk="usuario.pk"
							:empresaDisabled="true"
							:removeError="removeError"
							:edicao="true"
						/>

						<div
							class="flex flex-col-reverse md:flex-row flex-wrap justify-end md:p-5"
						>
							<ld-button
								v-if="
									$permissions.can('colaboradormodificar') ||
										$permissions.can('autenticadosuperuser')
								"
								type="border"
								class="md:mr-4 md:w-auto md:mt-0 mt-2 w-full"
								@click="popupCancelarEdicao = true"
							>
								Cancelar
							</ld-button>
							<ld-button
								v-if="
									$permissions.can('colaboradormodificar') ||
										$permissions.can('autenticadosuperuser')
								"
								class="md:w-auto md:mt-0 mt-2 w-full"
								buttonType="submit"
							>
								Salvar alterações
							</ld-button>

							<ld-button
								v-if="
									!$permissions.can('colaboradormodificar') &&
										!$permissions.can('autenticadosuperuser')
								"
								type="border"
								class="md:w-auto w-full"
								@click="cancelarEdicao"
							>
								Fechar
							</ld-button>
						</div>
					</form>
				</vx-card>


				<ld-popup
					title="Cancelar edição?"
					:active.sync="popupCancelarEdicao"
					:button-close-hidden="true"
				>
					<p>
						Tem certeza que deseja cancelar a edição do usuário? Se
						cancelar, todos os dados inseridos serão perdidos.
					</p>

					<vs-divider />

					<div class="button-container">
						<div class="button-group flex justify-end">
							<ld-button
								buttonType="submit"
								class="w-20 mr-4"
								color="danger"
								type="filled"
								@click="cancelarEdicao"
								>Cancelar edição</ld-button
							>

							<ld-button
								class="w-15"
								color="dark"
								type="flat"
								@click="popupCancelarEdicao = false"
								>Voltar</ld-button
							>
						</div>
					</div>
				</ld-popup>

				<ld-popup
					title="Usuário alterado"
					:active.sync="popupUsuarioEditado"
					:button-close-hidden="true"
					:disabledBackgoundClose="true"
				>
					<p>
						O usuário "{{ usuario ? usuario.nome : "" }}" foi alterado.
					</p>

					<vs-divider />

					<div class="button-container">
						<div class="button-group flex justify-end">
							<vs-button
								class="w-32"
								color="primary"
								type="filled"
								@click="edicaoFinalizada"
								>OK</vs-button
							>
						</div>
					</div>
				</ld-popup>

				<ld-popup
					:title="
						copiaUsuario && copiaUsuario.bloqueado
							? 'Usuário bloqueado'
							: 'Usuário desbloqueado'
					"
					:active.sync="popupUsuarioBloqueado"
					:button-close-hidden="true"
					:disabledBackgoundClose="true"
				>
					<p>
						O usuário "{{ usuario ? usuario.nome : "" }}" foi
						{{
							copiaUsuario && copiaUsuario.bloqueado
								? "bloqueado"
								: "desbloqueado"
						}}.
					</p>

					<vs-divider />

					<div class="button-container">
						<div class="button-group flex justify-end">
							<vs-button
								class="w-64 mr-4"
								color="primary"
								type="flat"
								@click="bloqueioFinalizado"
								>Ir para lista de usuários</vs-button
							>

							<vs-button
								class="w-64"
								color="primary"
								type="filled"
								@click="popupUsuarioBloqueado = false"
								>Continuar editando</vs-button
							>
						</div>
					</div>
				</ld-popup>

				<ld-popup
					:title="
						usuario && usuario.bloqueado === 'Bloqueado'
							? 'Desbloqueio de usuário'
							: 'Bloqueio de usuário'
					"
					:active.sync="popupBloquearUsuario"
					:button-close-hidden="true"
				>
					<p>
						Tem certeza que deseja
						{{
							usuario && usuario.bloqueado === "Bloqueado"
								? "desbloquear"
								: "bloquear"
						}}
						o usuário {{ usuario ? usuario.nome : "" }}?
					</p>

					<vs-divider />

					<div class="button-container">
						<div class="button-group flex justify-end">
							<ld-button
								class="w-15 mr-4"
								color="dark"
								type="flat"
								@click="popupBloquearUsuario = false"
								>Cancelar</ld-button
							>

							<ld-button
								buttonType="submit"
								class="w-20"
								:color="
									usuario && usuario.bloqueado === 'Bloqueado'
										? 'success'
										: 'danger'
								"
								type="filled"
								@click="bloqueioUsuario"
								>{{
									usuario && usuario.bloqueado === "Bloqueado"
										? "Desbloquear"
										: "Bloquear"
								}}</ld-button
							>
						</div>
					</div>
				</ld-popup>
			</template>
		</ld-popup>
	</div>
</template>

<script>
import Geral from "../components/geral/Geral";
import EstruturaPermissao from "../components/estrutura_permissao/EstruturaPermissao";
import Usuario from "../../../models/Usuario";
import Empresa from "../../../models/Empresa";
import ErrorHelper from "../../../helpers/ErrorHelper";
import StringHelper from "../../../helpers/StringHelper";
import Perfil from "../../../models/Perfil";
import DateHelper from '../../../helpers/DateHelper';

export default {
	name: "UsuarioAdicionar",
	data() {
		return {
			usuario: null,
			popupCancelarEdicao: false,
			popupUsuarioEditado: false,
			popupBloquearUsuario: false,
			popupUsuarioBloqueado: false,
			limitParamEmpresa: 20,
			empresas: null,
			perfilAtualPk: null,
			copiaUsuario: null,
			errors: null
		};
	},
	props: {
		active: {
			type: Boolean,
			default: false
		},
		closed: {
			type: Function,
			required: false
		},
		usuarioPk: {
			required: true
		}
	},
	components: {
		Geral,
		EstruturaPermissao
	},
	computed: {
		empresaPk() {
			try {
				return this.$route.params.empresaPk;
			} catch (error) {
				return null;
			}
		},
		activePopup: {
			set(value) {
				this.$emit("update:active", value);
			},
			get() {
				return this.active;
			}
		}
	},
	methods: {
		async getEmpresa() {
			if (this.empresaPk) {
				const empresa = await Empresa.getEmpresa(this.empresaPk);

				if (empresa) {
					this.usuario.empresa = empresa;
				}
			}
		},
		async getEmpresas() {
			let listEmpresas = [];

			if (!this.empresaPk) {
				const { empresas } = await Empresa.getEmpresas({
					limit: this.limitParamEmpresa
				});

				listEmpresas = empresas;

				this.empresas = listEmpresas.map(empresa => {
					return {
						text: empresa.nome,
						value: empresa.pk,
						perfis: empresa.perfis
					};
				});
			}
		},
		async getUsuario() {
			let usuario = null;

			if (this.empresaPk && this.usuarioPk) {
				usuario = await Usuario.getUsuarioPorEmpresa(
					this.empresaPk,
					this.usuarioPk
				);
			} else if (this.usuarioPk) {
				usuario = await Usuario.getUsuario(this.usuarioPk);
			}

			if (usuario) {
				if (!usuario.perfil) {
					usuario.perfil = new Perfil({});
				}

				if (!usuario.empresa) {
					usuario.empresa = new Empresa({});
				}

				if (usuario.dataNascimento) {
					usuario.dataNascimento = DateHelper.convertDate(
						usuario.dataNascimento,
						null,
						"DD/MM/YYYY"
					)
				}

				this.usuario = usuario;
			}
		},
		async getUsuarioPorCPF() {
			try {
				if (
					this.usuario &&
					this.usuario.cpf &&
					this.usuario.cpf.length == 11
				) {
					const usuario = await Usuario.getUsuarioPorCpf(
						this.usuario.cpf
					);

					if (usuario) {
						this.usuario = Usuario.fromMap({
							...this.usuario,
							...usuario
						});
					}
				}
			} catch (error) {
				console.error(error);
			}
		},
		async editarUsuario() {
			const loadingEditarUsuario = this.$vsloading({
				container: "#popup-editar-usuario",
				color: "#000000",
				backgroundColor: "#ffffffba",
				opacity: 1,
				width: 44,
				height: 44
			});

			this.errors = null;

			try {
				if (this.empresaPk) {
					await Usuario.editar(this.usuario, this.empresaPk);
				} else {
					await Usuario.editar(this.usuario);
				}

				this.popupUsuarioEditado = true;
			} catch (error) {
				this.errors = error;
				ErrorHelper.renderFormError("#form-editar-usuario", error);
			} finally {
				loadingEditarUsuario.hide();
			}
		},
		removeError(field) {
			if (!this.errors) return null;
			if (!field) return null;

			const { fields_errors } = this.errors;

			if (fields_errors) {
				const newErrors = fields_errors.filter(field_error => {
					return field != field_error.field;
				});

				this.errors.fields_errors = newErrors;
			}
		},
		cancelarEdicao() {
			this.popupCancelarEdicao = false;
			this.activePopup = false;
		},
		edicaoFinalizada() {
			this.popupUsuarioEditado = false;
			this.activePopup = false;
		},
		async bloqueioUsuario() {
			this.popupBloquearUsuario = false;

			const loadingBloqueioUsuario = this.$vsloading({
				container: "#popup-editar-usuario",
				color: "#000000",
				backgroundColor: "#ffffffba",
				opacity: 1,
				width: 44,
				height: 44
			});

			try {
				this.copiaUsuario.bloqueado =
					this.usuario.bloqueado === "Bloqueado" ? false : true;

				if (this.empresaPk) {
					await Usuario.editar(this.copiaUsuario, this.empresaPk);
				} else {
					await Usuario.editar(this.copiaUsuario);
				}

				this.usuario.bloqueado = this.copiaUsuario.bloqueado
					? "Bloqueado"
					: "Desbloqueado";
				this.popupUsuarioBloqueado = true;
			} catch (error) {
				ErrorHelper.renderFormError("#form-editar-usuario", error);
			} finally {
				loadingBloqueioUsuario.hide();
			}
		},
		bloqueioFinalizado() {
			this.popupUsuarioBloqueado = false;
			this.activePopup = false;
		},
		funcaoFechar() {
			if (this.closed) {
				this.closed();
			}

			this.usuario = null;
			this.perfilAtualPk = null;
			this.errors = null;

			const form = document.querySelector("#form-editar-usuario");
			ErrorHelper.cleanFormErrors(form);
		},
		async getInitialData() {
			await this.getEmpresas(),
			await this.getUsuario(),
			await this.getEmpresa()
		}
	},
	watch: {
		active() {
			if (this.active) {
				const loadingEmpresa = this.$vsloading({
					container: "#popup-editar-usuario",
					color: "#000000",
					backgroundColor: "#ffffffba",
					opacity: 1,
					width: 44,
					height: 44
				});

				Promise.all([
					this.getInitialData()
				])
					.then(() => {
						this.copiaUsuario = new Usuario(
							JSON.parse(JSON.stringify(this.usuario))
						);
					})
					.catch(error => {
						console.error(error);
					})
					.finally(() => {
						loadingEmpresa.hide();
					});
			}
		},
		"usuario.cpf": function(novoCpf, cpf) {
			const oldCpf = StringHelper.alphanumericOnly(cpf);
			const newCpf = StringHelper.alphanumericOnly(novoCpf);

			if (this.active && newCpf && oldCpf && newCpf != oldCpf) {
				this.getUsuarioPorCPF();
			}
		}
	}
};
</script>

<style lang="scss" src="./usuario_editar.scss"></style>
